app.controller('popupDeleteConfirmationController', ['$mdDialog', '$injector', 'objectHelper', 'title',
    'message', 'labels', 'yesText', 'noText', 'item', 'userModel',
    function ($mdDialog, $injector, objectHelper, title, message, labels, yesText, noText, item, userModel) {

        function setData() {
            this.title = (title ? title : 'T.DATA.ALERT');
            this.message = message;
            this.labels = labels;
            this.yesText = (yesText ? yesText : 'T.UI.APPLICATION.YES');
            this.noText = (noText ? noText : 'T.UI.APPLICATION.NO');
            this.item = item;
            this.item.deletionDate = new Date();
            this.item.deleted = true;

            this.user = userModel.currentUser;

            this.forms =  {
                deleteConfirm: null
            };
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            this.ok = function () {

                this.forms.deleteConfirm.$setSubmitted();
                if (this.forms.deleteConfirm.$valid) {
                    $mdDialog.hide(this.item);
                }
            };

            this.cancel = function () {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {
        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
